export default __webpack_public_path__ + "static/media/O-027.e30f53ef.png";